const BASEURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Without detailsHtml (several MB with its images): fetchProductDetailsHtml loads it afterwards.
export const fetchProductById = async (productId) => {
  try {
    const response = await fetch(`${BASEURL}/Product/byId/${productId}?details=false`);

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch product:', error);
    throw error;
  }
};

// Long content of the product page (HTML), loaded once the page is displayed.
export const fetchProductDetailsHtml = async (productId) => {
  const response = await fetch(`${BASEURL}/Product/DetailsHtml/${productId}`);
  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${response.statusText}`);
  }
  return await response.text();
};

export const addToCart = async (productData) => {
  try {
    // Implement cart API call here when available
    // For now, we'll use localStorage
    const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    
    // Check if item already exists in cart
    const existingItemIndex = existingCart.findIndex(
      item => item.id === productData.id && item.variantId === productData.variantId
    );
    
    if (existingItemIndex >= 0) {
      // Update quantity if item exists
      existingCart[existingItemIndex].quantity += productData.quantity;
    } else {
      // Add new item
      existingCart.push(productData);
    }
    
    localStorage.setItem('cart', JSON.stringify(existingCart));
    return { success: true, cartItems: existingCart };
  } catch (error) {
    console.error('Failed to add to cart:', error);
    throw error;
  }
};